import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isEqual, isEmpty, cloneDeep, uniq } from "lodash";


import {
  PageWrapper,
  Loader,
  Alert,
  ImageSelector as Image,
} from "../../components";
import Actions, { thunks } from "../../redux/modules/products";
import { formatCategory } from "../../utils/format";
import { TOTAL_IMAGE_NUM, INDEX_TO_NAME } from "../../constants";
import { CombineProductsModal } from "../../components";
import ImagePlaceholder from "../../assets/img/img_placeholder.jpg";
// let deletedImageArray =[]
class ProductDetails extends Component {
  state = {
    images: [...Array(TOTAL_IMAGE_NUM)],
    disableSave: true,
    numImages: 0,
    isShowDeliveryDays: false,
    isMultiProductsTab: false,
    isDescriptionTab: false,
    inventoryTab: false,
    inStockQty: 0,
    outStockQty: 0,
    isOutOfStockDeliverable: 1,
    description: "",
    isShowFranchiseCommission: false,
    isAgentCommission: 1,
    agentFirstOrder: 0,
    fixedCommission: 0,
    salesFirstOrder: 0,
    showModal: false,
    products: [],
    errors: {},
  };

  componentDidMount() {
    const {
      dispatch,
      match: {
        params: { id },
      },
      data,
    } = this.props;
    dispatch(thunks.getProductDetails(id));
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;

    if (
      !isEqual(data, prevProps.data) &&
      data.productImages &&
      data.productImages.length
    ) {
      const { images } = cloneDeep(this.state);
      data.productImages.map((image, index) => (images[index] = image));
      this.setState({ images, numImages: data.productImages.length });
    }
    if (
      !isEqual(data.deliveryPeriod, prevProps.data.deliveryPeriod) &&
      data.deliveryPeriod
    ) {
      this.setState({
        inStockQty: data.deliveryPeriod.inStock,
        outStockQty: data.deliveryPeriod.outOfStock,
        isOutOfStockDeliverable: data.isOutOfStockDeliverable,
      });
    }
    if (
      !isEqual(data.description, prevProps.data.description) &&
      data.description
    ) {
      this.setState({
        description: data.description,
      });
    }

    if (
      !isEqual(data.commission, prevProps.data.commission) &&
      data.commission
    ) {
      console.log(data.commission);
      this.setState({
        agentFirstOrder: data.commission.agentCommission.firstOrder,
        fixedCommission: data.commission.agentCommission.fixedCommission,
        salesFirstOrder: data.commission.salesmanCommission.firstOrder,
      });
    }

    if (
      !isEqual(data.combinedProducts, prevProps.data.combinedProducts) &&
      data.combinedProducts &&
      data.combinedProducts.length > 0
    ) {
      this.setState((state) => ({
        products: data.combinedProducts,
      }));
    }
  }
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(thunks.clearProductDetails());
  }

  onChangeImage = (e, index) => {
    const { images, numImages } = this.state;

    images[index] = e.target.files[0];
    this.setState({ images, disableSave: false, numImages: numImages + 1 });
  };
  onDeleteImage = (e, index) => {
    const { images, numImages } = this.state;

    // let deletedImageArray = deletedImageArray.concat(deletedImage);
    this.setState({ images, numImages: numImages - 1 });
    // console.log("dfgdfgdfgdfgdfgdfgdfgdfg",deletedImageArray)
    const { dispatch, data } = this.props;
    if (numImages == 1) this.setState({ disableSave: true });
    if (images && images.length > 0) {
      let deletedImage = images.splice(index, 1);
      if (
        deletedImage &&
        typeof deletedImage == "object" &&
        !deletedImage[0].name
      ) {
        deletedImage.splice(0, 1, deletedImage[0].split("/").slice(-1)[0]);
        dispatch(thunks.deleteProductImages(data.productId, deletedImage));
      }
    }
  };
  saveImages = () => {
    const files = new FormData();
    const { images } = this.state;
    const { dispatch, data } = this.props;
    images.map((image, index) => {
      if (image && typeof image !== "string")
        files.append(INDEX_TO_NAME[index], image);
    });
    dispatch(thunks.uploadProductImages(data.productId, files));
  };

  saveDeliveryDays = () => {
    const { dispatch, data } = this.props;
    let body = {
      isOutOfStockDeliverable: this.state.isOutOfStockDeliverable,
      deliveryPeriod: {
        inStock: this.state.inStockQty,
        outOfStock: this.state.outStockQty,
      },
    };
    // if(this.state.isOutOfStockDeliverable == 0 || this.state.outStockQty==0)
    // delete body.deliveryPeriod.outOfStock
    // if(this.state.inStockQty==0)
    // delete body.deliveryPeriod.inStock
    dispatch(thunks.saveProductDetails(data.productId, body));
  };

  saveCommision = () => {
    const { dispatch, data } = this.props;
    let body = {
      commission: {
        agentCommission: {
          firstOrder: this.state.agentFirstOrder,
          fixedCommission: this.state.fixedCommission,
        },
        salesmanCommission: { firstOrder: this.state.salesFirstOrder },
      },
    };
    dispatch(thunks.saveProductDetails(data.productId, body));
  };

  saveDescription = () => {
    const { dispatch, data } = this.props;
    let body = {
      description: this.state.description,
    };
    dispatch(thunks.saveProductDetails(data.productId, body));
  };
  toggleCombineProducts = () => {
    this.setState((state) => ({
      showModal: !state.showModal,
    }));
  };
  onSelectProduct = (product) => {
    const { products } = this.state;
    products.push(product);
    this.setState((state) => ({
      products,
      showModal: false,
      errors: {
        ...state.errors,
        products: "",
      },
    }));
  };
  removeProduct = (product) => {
    const { products } = this.state;
    this.setState({
      products: products.filter((p) => p.productId !== product.productId),
    });
  };
  saveMultipleProducts = (e) => {
    const { products } = this.state;
    const body = {
      productIds: uniq(products.map((product) => product.productId.toString())),
      productId: this.props.data.productId.toString(),
    };
    this.props.dispatch(thunks.combineProducts(body, this.props.history));
    setTimeout(() => {}, 1000);
  };

  handleInventory = (e) => {
    this.setState({
      isShowFranchiseCommission: false,
      isShowDeliveryDays: false,
      isMultiProductsTab: false,
      isDescriptionTab: false,
      inventoryTab: true,
    });
  };

  render() {
    const { data, loading, error, updateProperty } = this.props;
    const { images, disableSave, numImages, products } = this.state;
    let sampleObj = {
      array: [],
    };
    for (var l = 0; l <= 100; l++) {
      sampleObj.array[l] = l;
    }
    let optionItems = sampleObj.array.map((item) => (
      <option key={item}>{item}</option>
    ));

    return (
      <PageWrapper title="Product Details">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Products"
          message={error}
        />
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">Product Details</div>
              {!isEmpty(data) ? (
                <div className="card-block">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <div className="d-flex justify-content-center align-items-center">
                          <h4 className="flex-1">{data.title}</h4>
                          {/* <span
                            className={classNames("badge", {
                              "badge-success": data.inStock,
                              "badge-danger": !data.inStock,
                            })}
                          >
                            {!data.inStock && "Not "}Available
                          </span> */}
                          <span className="badge badge-success">Available</span>
                        </div>
                        <p>{data.description}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Category</label>
                        <p className="text-capitalize">
                          {formatCategory(data.categoryName)}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Sub Category</label>
                        <p className="text-capitalize">
                          {formatCategory(data.subcategoryName)}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Material</label>
                        <p className="text-capitalize">
                          {formatCategory(data.material)}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Pattern</label>
                        <p className="text-capitalize">{data.pattern || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Ideal For</label>
                        <p className="text-capitalize">
                          {data.idealFor || "-"}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Finish</label>
                        <p className="text-capitalize">{data.finish || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Feature</label>
                        <p className="text-capitalize">{data.feature || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Price</label>
                        <p>{`${data.price} ${data.unitPrice}` || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Size</label>
                        <p>{data.size || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Thickness</label>
                        <p>{data.thickness || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="form-group">
                        <label>Tags</label>
                        <p className="text-capitalize">
                          {data.tags ? data.tags.join(", ") : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 d-flex align-items-center">
                      <h4>Product images</h4>
                      <small className="ml-2">
                        (Max. 20 images can be uploaded)
                      </small>
                    </div>
                  </div>
                  <div className="d-flex mt-2 pb-3 overflow-x-scroll">
                    {images.map((image, index) => (
                      <Image
                        src={image}
                        onChangeImage={(e) => this.onChangeImage(e, index)}
                        key={index}
                        showButton={numImages === index}
                        onDeleteImage={(e) => this.onDeleteImage(e, index)}
                      />
                    ))}
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={this.saveImages}
                        disabled={disableSave}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn btn-success mt-3 ml-2"
                        onClick={() =>
                          this.setState({
                            isMultiProductsTab: true,
                            isShowFranchiseCommission: false,
                            isShowDeliveryDays: false,
                            isDescriptionTab: false,
                            inventoryTab: false,
                          })
                        }
                      >
                        {" "}
                        Add Multiple Products
                      </button>
                      <button
                        className="btn btn-primary mt-3 ml-2"
                        onClick={() =>
                          this.setState({
                            isShowDeliveryDays: true,
                            isShowFranchiseCommission: false,
                            isMultiProductsTab: false,
                            isDescriptionTab: false,
                            inventoryTab: false,
                          })
                        }
                      >
                        {" "}
                        {data.deliveryPeriod
                          ? "Edit Delivery Days"
                          : "Add Delivery Days"}
                      </button>
                      <button
                        className="btn btn-pink mt-3 ml-2"
                        onClick={() =>
                          this.setState({
                            isShowFranchiseCommission: true,
                            isShowDeliveryDays: false,
                            isMultiProductsTab: false,
                            isDescriptionTab: false,
                            inventoryTab: false,
                          })
                        }
                      >
                        {" "}
                        {this.isShowDeliveryDays
                          ? "Edit Commission"
                          : "Add Commission"}
                      </button>
                      <button
                        className="btn btn-dark mt-3 ml-2"
                        onClick={() =>
                          this.setState({
                            isShowFranchiseCommission: false,
                            isShowDeliveryDays: false,
                            isMultiProductsTab: false,
                            isDescriptionTab: true,
                            inventoryTab: false,
                          })
                        }
                      >
                        {" "}
                        Add Description
                      </button>
                      <button
                        className="btn btn-danger mt-3 ml-2"
                        onClick={this.handleInventory}
                      >
                        Inventory
                      </button>
                    </div>
                  </div>
                  {this.state.showModal ? (
                    <CombineProductsModal
                      show={this.state.showModal}
                      onHide={this.toggleCombineProducts}
                      onSelect={this.onSelectProduct}
                    />
                  ) : null}

                  {this.state.isMultiProductsTab ? (
                    <>
                      <div className="bg-secondary m-2">
                        <div className="row align-items-center">
                          {products &&
                            products.length > 0 &&
                            products.map((product) => (
                              <div key={product.productId} className="col-md-3">
                                <div className="bg-white d-flex m-2 p-2">
                                  {
                                    <img
                                      src={
                                        product.productImages.length
                                          ? product.productImages[0]
                                          : ImagePlaceholder
                                      }
                                      alt={product.title}
                                      width="80px"
                                    />
                                  }
                                  <div className="flex-1 d-flex align-items-center">
                                    <p className="ml-2">{product.title}</p>
                                  </div>
                                  <div className="center-item">
                                    <button
                                      className="btn btn-danger"
                                      onClick={() =>
                                        this.removeProduct(product)
                                      }
                                    >
                                      <i className="fa fa-trash" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          <div className="col-md-2 mt-3">
                            <div className="form-group">
                              <button
                                title="Add To Hotlook"
                                className="btn btn-xs btn-primary ml-2"
                                onClick={this.toggleCombineProducts}
                              >
                                <i className="fa fa-plus" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={this.saveMultipleProducts}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {this.state.isShowDeliveryDays ? (
                    <>
                      <div className="bg-secondary m-2">
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-2 m-4">
                            <div className="form-group">
                              <h6 className="text-success">IN STOCK</h6>
                              <select
                                className="form-control"
                                onChange={(e) =>
                                  this.setState({ inStockQty: e.target.value })
                                }
                                value={this.state.inStockQty}
                              >
                                {optionItems}
                              </select>
                            </div>
                          </div>
                          {this.state.isOutOfStockDeliverable == 1 ? (
                            <div className="col-md-2 m-4">
                              <div className="form-group">
                                <h6 className="text-danger">OUT OF STOCK</h6>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    this.setState({
                                      outStockQty: e.target.value,
                                    })
                                  }
                                  value={this.state.outStockQty}
                                >
                                  {optionItems}
                                </select>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="row d-flex justify-content-center p-2">
                          <div className="col-md-2">
                            {" "}
                            <h6>Need out of stock option</h6>{" "}
                          </div>
                          <div className="col-md-2">
                            <div className="form-check form-check-inline">
                              <h6>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  onChange={(e) =>
                                    this.setState({
                                      isOutOfStockDeliverable: e.target.value,
                                    })
                                  }
                                  checked={
                                    this.state.isOutOfStockDeliverable == 1
                                  }
                                  name="inlineRadioOptions"
                                  id="inlineRadio1"
                                  value="1"
                                />
                                <label className="form-check-label">Yes</label>
                              </h6>
                            </div>

                            <div className="form-check form-check-inline">
                              <h6>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  onChange={(e) =>
                                    this.setState({
                                      isOutOfStockDeliverable: e.target.value,
                                      outStockQty: 0,
                                    })
                                  }
                                  checked={
                                    this.state.isOutOfStockDeliverable == 0
                                  }
                                  id="inlineRadio2"
                                  value="0"
                                />
                                <label className="form-check-label">No</label>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={this.saveDeliveryDays}
                            disabled={
                              this.state.inStockQty == 0 &&
                              this.state.outStockQty == 0
                            }
                          >
                            {data.deliveryPeriod ? "Update" : "Add"}
                          </button>
                        </div>
                      </div>
                    </>
                  ) : this.state.isShowFranchiseCommission ? (
                    <>
                      <div className="bg-secondary p-4 m-2">
                        <div className="row">
                          <div className="col-md-2">
                            <div className="form-check form-check-inline">
                              <h6>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  onChange={(e) =>
                                    this.setState({
                                      isAgentCommission: e.target.value,
                                    })
                                  }
                                  checked={this.state.isAgentCommission == 1}
                                  name="inlineRadioOptions"
                                  id="inlineRadio1"
                                  value="1"
                                />
                                <label className="form-check-label">
                                  Franchise Commission
                                </label>
                              </h6>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-check form-check-inline">
                              <h6>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  onChange={(e) =>
                                    this.setState({
                                      isAgentCommission: e.target.value,
                                    })
                                  }
                                  checked={this.state.isAgentCommission == 0}
                                  id="inlineRadio2"
                                  value="0"
                                />
                                <label className="form-check-label">
                                  Sales Person Commission
                                </label>
                              </h6>
                            </div>
                          </div>
                        </div>
                        {this.state.isAgentCommission == 1 ? (
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <div className="form-group">
                                <h6>First Commission(%)</h6>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    this.setState({
                                      agentFirstOrder: e.target.value,
                                    })
                                  }
                                  value={this.state.agentFirstOrder}
                                >
                                  {optionItems}
                                </select>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="form-group">
                                <h6>Second Commission(%)</h6>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    this.setState({
                                      fixedCommission: e.target.value,
                                    })
                                  }
                                  value={this.state.fixedCommission}
                                >
                                  {optionItems}
                                </select>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <div className="form-group">
                                <h6>First Commission(%)</h6>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    this.setState({
                                      salesFirstOrder: e.target.value,
                                    })
                                  }
                                  value={this.state.salesFirstOrder}
                                >
                                  {optionItems}
                                </select>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={this.saveCommision}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {this.state.isDescriptionTab ? (
                    <>
                      <div className="bg-secondary m-2">
                        <div className="row align-items-center">
                          {/* {products && products.length > 0 && products.map(product => (
                                                <div key={product.productId} className="col-md-3">
                                                    <div className="bg-white d-flex m-2 p-2">
                                                        {<img src={product.productImages.length ? product.productImages[0] : ImagePlaceholder} alt={product.title} width="80px" />}
                                                        <div className="flex-1 d-flex align-items-center">
                                                            <p className="ml-2">{product.title}</p>
                                                        </div>
                                                        <div className="center-item">
                                                            <button className="btn btn-danger" onClick={() => this.removeProduct(product)}>
                                                                <i className="fa fa-trash" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))} */}
                          {/* <div className="col-md-2 mt-3">
                                                <div className="form-group">
                                                    <button title="Add To Hotlook" className="btn btn-xs btn-primary ml-2" onClick={this.toggleCombineProducts}>
                                                        <i className="fa fa-plus" />
                                                    </button>
                                                </div>
                                            </div> */}
                          <div className="col-md-6 m-2">
                            <div className="form-group">
                              <label for="exampleFormControlTextarea1">
                                Enter description
                              </label>
                              <textarea
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                rows="3"
                                maxLength="50"
                                value={this.state.description}
                                onChange={(e) =>
                                  this.setState({
                                    description: e.target.value,
                                  })
                                }
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={this.saveDescription}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {this.state.inventoryTab ? (
                    <>
                      <div className="bg-secondary m-2">
                        <div className="row d-flex justify-content-center">
                          <div className="text-success mt-5">Stock</div>
                          <div className="col-md-2 mt-4">
                            <label> </label>
                            <div className="form-group">
                              <select
                                className="form-control"
                                onChange={(e) =>
                                  this.setState({ inStockQty: e.target.value })
                                }
                                value={this.state.inStockQty}
                              >
                                {optionItems}
                              </select>
                            </div>
                          </div>
                          <div className="text-danger mt-5">Return</div>
                          <div className="col-md-3 mt-4">
                            <lable>Fresh</lable>
                            <div className="form-group">
                              <select
                                className="form-control"
                                onChange={(e) =>
                                  this.setState({
                                    outStockQty: e.target.value,
                                  })
                                }
                                value={this.state.outStockQty}
                              >
                                {optionItems}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-3 mt-4">
                            <lable>Damage</lable>
                            <div className="form-group">
                              <select
                                className="form-control"
                                onChange={(e) =>
                                  this.setState({
                                    outStockQty: e.target.value,
                                  })
                                }
                                value={this.state.outStockQty}
                              >
                                {optionItems}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={this.saveDescription}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({ products: { loading, error, data } }) => ({
  loading,
  error,
  data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
